module.exports = __webpack_public_path__ + "img/card-heading.f93a6134.svg";